import { EnquiryLifecycleStatusEnum,OrderTypeEnum } from "../enum";
import { EnquiyProductDetaiils } from "./enquiry-management-product-responsemodel";

export class enquiryInfo{
    enquiryId:number
    enquiryNumber:string
    orderType:OrderTypeEnum
    sourceFrom:string
    agentId:number
    agentName:string
    buyerId:number
    buyerName:string
    salePersonId:number
    salePersonName:number
    enquiryDate:Date
    noOfContainers:number
    agentAddressId:number
    agentAddress:string
    buyerAddresId:number
    buyerAddres:string
    countryId:number
    countryName:number
    destinationId:number
    destinationName:number
    etd:string
    toEtd:string
    eta:string
    deliveryTermsId:number
    deliveryTerms:string
    paymentTermsId:number
    paymentTerms:string
    shipmentTermsId:number
    shipmentTerms:string
    procesingUnit:number
    procesingUnitName:string
    manufacturingUnit:number
    manufacturingUnitName:string
    currency:number
    remarks:string
    createdUser:string
    updateUser:string
    lifeCycleStatus:EnquiryLifecycleStatusEnum
    unitId:number
    EnquiryRejectReason:string
    productDetails:EnquiyProductDetaiils[]
    aging?:number
    statusAging?:number
    unitName?:string
    isFOB?:boolean
    cancelReason?:string
constructor(
    enquiryId:number,
    enquiryNumber:string,
    orderType:OrderTypeEnum,
    sourceFrom:string,
    agentId:number,
    agentName:string,
    buyerId:number,
    buyerName:string,
    salePersonId:number,
    salePersonName:number,
    enquiryDate:Date,
    noOfContainers:number,
    agentAddressId:number,
    agentAddress:string,
    buyerAddresId:number,
    buyerAddres:string,
    countryId:number,
    countryName:number,
    destinationId:number,
    destinationName:number,
    etd:string,
    toEtd:string,
    eta:string,
    deliveryTermsId:number,
    deliveryTerms:string,
    paymentTermsId:number,
    paymentTerms:string,
    shipmentTermsId:number,
    shipmentTerms:string,
    procesingUnit:number,
    procesingUnitName:string,
    manufacturingUnit:number,
    manufacturingUnitName:string,
    currency:number,
    remarks:string,
    createdUser:string,
    updateUser:string,
    lifeCycleStatus:EnquiryLifecycleStatusEnum,
    unitId:number,
    EnquiryRejectReason:string,
    productDetails:EnquiyProductDetaiils[],
    aging?:number,
    statusAging?:number,
    unitName?:string,
    isFOB?:boolean,
    cancelReason?:string

){
this.enquiryId=enquiryId
this.enquiryNumber=enquiryNumber
this.orderType=orderType
this.sourceFrom=sourceFrom
this.agentId               =agentId                
this.agentName             =agentName              
this.buyerId               =buyerId                
this.buyerName             =buyerName              
this.salePersonId          =salePersonId           
this.salePersonName        =salePersonName         
this.enquiryDate           =enquiryDate            
this.noOfContainers        =noOfContainers         
this.agentAddressId        =agentAddressId         
this.agentAddress          =agentAddress           
this.buyerAddresId         =buyerAddresId          
this.buyerAddres           =buyerAddres            
this.countryId             =countryId              
this.countryName           =countryName            
this.destinationId         =destinationId          
this.destinationName       =destinationName        
this.etd                   =etd                    
this.toEtd                   =toEtd                    
this.eta                   =eta                    
this.deliveryTermsId       =deliveryTermsId        
this.deliveryTerms         =deliveryTerms          
this.paymentTermsId        =paymentTermsId         
this.paymentTerms          =paymentTerms           
this.shipmentTermsId       =shipmentTermsId        
this.shipmentTerms         =shipmentTerms          
this.procesingUnit         =procesingUnit          
this.procesingUnitName     =procesingUnitName      
this.manufacturingUnit     =manufacturingUnit      
this.manufacturingUnitName =manufacturingUnitName  
this.currency              =currency               
this.remarks               =remarks                
this.createdUser           =createdUser            
this.updateUser            =updateUser             
this.lifeCycleStatus       =lifeCycleStatus        
this.unitId                =unitId                 
this.EnquiryRejectReason   =EnquiryRejectReason    
this.productDetails        =productDetails  
this.aging =aging       
this.statusAging=statusAging
this.unitName=unitName
this.isFOB = isFOB
this.cancelReason = cancelReason
}
}